<template>

<section class="organization-setting">

    <b-tabs v-model="activeTab" @change="loadTabById" ref="tabs">

<!--         <b-tab-item label="Details">

            <form enctype="multipart/form-data" ref="form">

                <div class="columns">

                    <div class="column">
                        
                          <b-field>

                            <p class="logo">Logo</p>
                            
                            <b-upload v-model="logo" accept="image/*">
                             
                              <b-button icon-left="upload" tag="a">
                             
                                <span>{{ logo ? logo.name : "Choose File" }}</span>
                             
                              </b-button>
                            
                            </b-upload>

                          </b-field>

                    </div>

                    <div class="column">

                        <br>

                        <div v-if="selectedFirm.firm.logo" class="image-logo">

                          <figure class="image is-fullwidth">

                            <img :src="selectedFirm.firm.logo.path" class="logo">

                          </figure>

                        </div>
                        
                    </div>

                </div>

                <b-field label="Code">
                
                    <b-input v-model="form.councilId"></b-input>
                
                </b-field>

                <br>

                <tags-input label="Tags" allow-new :values.sync="selectedtags" />

                <br>

                <b-field label="Your Rating" v-if="organization" class="rating-div">
                
                    <star-rating class="mb-1" :increment ="0.1" :rating="doneRate.rating" :star-size="20" :show-rating="false" read-only v-if="doneRate"/>

                    <star-rating class="mb-1" :increment ="0.1" :rating="0" :star-size="20" :show-rating="false" read-only v-else />

                    <template v-if="canRate && !doneRate">

                        <button class="button rate-button" type="button" @click="modal.active = true">Rate</button>

                        <b-modal :active.sync="modal.active" has-modal-card>

                            <rating-modal :rate="rate" />

                        </b-modal>

                    </template>
                    <br>
                    <p v-if="organization.ratings.length && doneRate">Notes: {{ doneRate.notes }}</p>

                </b-field>

                <br>
              
                <button type="button" class="button is-info is-fullwidth" @click="saveLogo">Save</button>

            </form>

        </b-tab-item> -->

        <!-- <b-tab-item label="Permissions" id="tab-permissions" v-if="$store.getters['Auth/hasPermission']('can manage permissions')">

            <organization-permission :organization="organization" @update-success="updatFirm" v-if="isTabLoaded('tab-permissions')" />
        
        </b-tab-item> -->

        <!-- <b-tab-item label="Attributes" id="tab-attributes" v-if="$store.getters['Auth/hasPermission']('can manage attributes')">

            <model-attributes :model="organization" type="firm" v-if="isTabLoaded('tab-attributes')" />

        </b-tab-item> -->

        <b-tab-item label="Brand" id="tab-brand" v-if="$store.getters['Auth/hasPermission']('can manage brand')">
        
            <organization-brand
              :firm="organization"
              :firm-association="selectedFirm"
              v-if="isTabLoaded('tab-brand')"
            />

        </b-tab-item>

        <b-tab-item label="Permissions" id="tab-permissions" v-if="$store.getters['Auth/hasPermission']('can manage firm permissions')">

          <organization-permission :organization="organization" @update-success="updatFirm" v-if="isTabLoaded('tab-permissions')" />

        </b-tab-item>

        <b-tab-item label="Attributes" id="tab-attributes" v-if="$store.getters['Auth/hasPermission']('can manage attributes')">

          <model-attributes :model="organization" type="firm" v-if="isTabLoaded('tab-attributes')" />

        </b-tab-item>

        <!-- <b-tab-item label="Portal">
            <PortalForm :portal.sync="portal" :model="organization" v-if="isTabLoaded(2)" />
        </b-tab-item> -->
        <b-tab-item label="Codes" id="tab-codes" v-if="$store.getters['Auth/hasPermission']('can manage codes')">
            <Codes :organization="organization" :firm="selectedFirm" v-if="isTabLoaded('tab-codes')" />
        </b-tab-item>
        <b-tab-item label="Roles" id="tab-roles" v-if="$store.getters['Auth/hasPermission']('can manage roles')">
            <organization-roles :organization="organization" :firm="selectedFirm" @refetchRoles="$emit('refetchRoles')" v-if="isTabLoaded('tab-roles')" />
        </b-tab-item>
        <b-tab-item label="Terminology" id="tab-terminology" v-if="$store.getters['Auth/hasPermission']('can manage terminologies')">
            <terminology v-if="isTabLoaded('tab-terminology')" />
        </b-tab-item>

        <b-tab-item label="Service Levels" id="tab-service-levels" v-if="$store.getters['Auth/hasPermission']('can manage service levels')">
            <service-levels :organization="organization" v-if="isTabLoaded('tab-service-levels')" />
        </b-tab-item>

        <b-tab-item label="Tags" id="tab-tags" v-if="canManageTags">
            <tags :organization="organization" v-if="isTabLoaded('tab-tags')" />
        </b-tab-item>

        <!-- <b-tab-item label="Rates" id="tab-rates" v-if="$store.getters['Auth/hasPermission']('can manage rates')">
            <organization-rates :organization="organization" :firm="selectedFirm" v-if="isTabLoaded('tab-rates')" />
        </b-tab-item> -->

        <b-tab-item label="Rates" id="tab-rates">
            <rate-table-new :firm="organization" v-if="isTabLoaded('tab-rates')" />
        </b-tab-item>

        <!-- <b-tab-item label="Rates (New)" id="tab-contract-rates">
            <OrganizationSettingsRates v-if="isTabLoaded('tab-contract-rates')" />
        </b-tab-item> -->

        <b-tab-item label="Assets" id="tab-assets">
            <OrganizationSettingsAssets v-if="isTabLoaded('tab-assets')" />
        </b-tab-item>

        <b-tab-item label="Contracts" id="tab-contracts" v-if="organization && organization.id == user.firmId && !organization.managed_by && $store.getters['Auth/hasPermission']('can manage contracts')">
            <organization-contracts :organization="organization" :firm="selectedFirm" v-if="isTabLoaded('tab-contracts')" />
        </b-tab-item>

    </b-tabs>

</section>

</template>

<script>

import { FirmService } from "@/services/firm.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import modelAttributes from '@/components/pages/Attributes/_partials/modelAttributes'
import TagsInput from "@/components/partials/TagsInput";
import { TagService } from "@/services/tag.service";
import StarRating from "vue-star-rating";
import RatingModal from "@/components/Rating/RatingModal";
import { tabsMixin } from "@/mixins/tabsMixin";
import PortalForm from "@/components/pages/Portals/partials/organizationPortalForm";
import OrganizationPermission from "./organizationPermission";
import Codes from "./codes";
import organizationRoles from "./organizationRoles";
import Terminology from "@/components/Terminology/Terminology";
import ServiceLevels from "@/components/pages/ServiceLevels/list";
import Tags from "@/components/pages/Tags/list";
import organizationRates from "./organizationRates";
import OrganizationContracts from "@/components/pages/Contracts/index";
import RateTableNew from "@/components/Rate/RateTableNew";
import OrganizationSettingsAssets from "./organizationSettingsAssets";
import OrganizationSettingsRates from "./organizationSettingsRates";
import OrganizationBrand from "./organizationBrand";

export default {
  props: {
    height: {
      type: Number,
      default: 500
    },
    organization: {
      type: Object,
      default: null
    },
    selectedFirm:{
      type: Object
    },
  },

  mixins: [tabsMixin],

  components:{
    modelAttributes,
    TagsInput,
    StarRating,
    RatingModal,
    OrganizationPermission,
    PortalForm,
    Codes,
    organizationRoles,
    Terminology,
    ServiceLevels,
    Tags,
    organizationRates,
    OrganizationContracts,
    RateTableNew,
    OrganizationSettingsAssets,
    OrganizationSettingsRates,
    OrganizationBrand,
  },

  data: () => ({
    firmService: FirmService,

    loading: false,

    form: {
      councilId: "",
      tags: []
    },

    logo: null,

    firmTags: [],

    activeTags: {},

    modal: {
        active: false
    },

    activeTab: 0,
    portal: null,
  }),

  computed: {
    scrollableHeight() {
      return this.height - 44 - 56; // header height, footer height
    },

    user() {
      return this.$store.state.Auth.user;
    },

    selectedtags: {

        get() {
            
            return this.selectedFirm.tags.filter(element => this.firmTags.every(tag => tag.id != element.id)).map(element => element.name);

        }, set(value) {

        }

    },

    doneRate() {

        return this.organization.ratings.find(element => {

            return element.createdBy == this.user.id;
            // return element.createdBy.id == this.user.id;

        });

    },

    canRate() {

        return this.$store.getters["Auth/hasFirmPermission"]("can rate firms");

    },
    canManageTags() {
      return this.$store.getters["Auth/hasPermission"]("can manage tags");
    },
  },

  watch: {

    organization(value) {



    },

    selectedFirm(value) {
        this.form.councilId = value.code;
        this.activeTags = {};
        this.firmHasPortal();
    },

  },

  methods: {
    async onSubmit() {
      
    },

    saveLogo() {

      FirmService.updateLogo(this.transformedData()).then(response => {

          // let firm = JsonDenormalizer.denormalize(response);

          this.$buefy.toast.open({
            message: "Successfully updated.",
            type: "is-info",
            position: "is-top-right"
          });

            this.$emit('updateFirm', response)


          // this.$emit('update:organization', firm);

          this.logo = null;

      });

    },

    transformedData() {

      let formData = new FormData(this.$refs.form);

      formData.append("file", this.logo);

      formData.append("firm_firm_id", this.selectedFirm.id);

      formData.append("firm_id", this.organization.id);

      formData.append("code", this.form.councilId);

      formData.append("tags", this.selectedtags.toString());

      let active_tags = [];

      Object.entries(this.activeTags).forEach(([key, value]) => {

        active_tags.push(value);
      
      });

      formData.append("active_tags", active_tags.toString());
      
      return formData;

    },

    async getTags() {

        await TagService.findtags({tags: ['customer', 'vendor']}).then(response => {

            this.firmTags = JsonDenormalizer.denormalize(response);

        });

    },

    tagExist(id) {


      let data = this.selectedFirm.tags.filter(element => element.id == id && element.pivot.archived_at == null);

      if (data.length) {

        this.activeTags[id] = data[0].id;

        return true;

      }

      return false;

    },


    firmTag(tag, event) {

        event.target.classList.toggle('is-loading');

        TagService.attachtag({tag: tag.id, parent_id: this.user.firmId, child_id: this.organization.id}).then(response => {

            event.target.classList.toggle('is-info');

            event.target.classList.toggle('is-loading');

            // this.$emit('updateFirm', response)

        });

    },

    async rate(data) {

        await FirmService.rate(this.organization.id, data).then(response => {

            this.$emit('updateOrganization', JsonDenormalizer.denormalize(response))

            this.modal.active = false;

        });

    },

    updatFirm() {

        this.$emit('updateFirm');

    },
    firmHasPortal() {
        FirmService.show(this.organization.id, {includes: 'portal'}).then(response => {
            let organization = JsonDenormalizer.denormalize(response);
            this.portal = organization.portal || null
        });
        // FirmService.getPortal(this.organization.id).then(response => {
        //     this.portal = response;
        // });
    }
  },

  mounted() {
    // Load initial tab
    this.loadTabById(0);

    this.getTags();
    this.firmHasPortal();
    this.form = {
        councilId: this.selectedFirm.code,
    }

  },

};
</script>

<style scoped>
  
  .organization-setting .has-addons{
    display: block;
  }

  .logo {
      font-size: 13px;
      font-weight: bold;
      margin-bottom: 10px;
  }

  .image-logo{
    max-width: 200px;
  }
    
/*    .tags-button{
        width: 50%;
        margin-top: 28px;
    }*/


</style>


// WEBPACK FOOTER //
// src/components/pages/Organization/organizationData/organizationSettings.vue